// eslint-disable-next-line unicorn/prefer-node-protocol
import { Buffer } from 'buffer'

export function convertObjectToBase64(payload: Record<string, unknown>): string {
  return Buffer.from(JSON.stringify(payload)).toString('base64')
}
